import { PropsWithChildren } from "react"
import classNames from "classnames"

import { UITypes } from "types"

import { Breadcrumbs } from "../Breadcrumbs"

import styles from "./index.module.scss"

interface Props extends PropsWithChildren {
  title?: string
  breadcrumbs?: UITypes.Breadcrumb[]
  className?: string
}

export const ContentWrapper = ({ title, children, breadcrumbs, className }: Props) => {
  return (
    <main className={classNames(styles.contentWrapper, className)}>
      {breadcrumbs && <Breadcrumbs list={breadcrumbs} />}
      <h2 className={styles.contentTitle}>{title}</h2>
      {children}
    </main>
  )
}
